/* DIYION — storefront behaviour.
   Generated from the approved prototype by theme-build.mjs.
   Products, cards and reviews are rendered by Liquid; this file only handles behaviour. */
/* ---------------------------------------------------------------------------
   DIYION core behaviour.

   Written for a real multi-template storefront: every lookup is null-safe and
   every binding is delegated or guarded, so a missing element on one template
   can never stop the rest of the bundle. The prototype's script assumed a
   single page where everything existed at once.

   Owns: lights, drawer, accordions, gallery, sticky buy bar, review filters.
   Does NOT own: variant selection, price maths, quantity, gift and tools
   toggles — those belong to the product section, which knows the variants.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = document.documentElement;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };

  /* ---------------------------------------------------------------- lights */
  function paintLamps() {
    var off = root.getAttribute('data-lights') === 'off';
    $$('.lamp[data-lamp]').forEach(function (b) {
      b.setAttribute('aria-pressed', off ? 'true' : 'false');
    });
    $$('[data-lamp]:not(.lamp)').forEach(function (b) {
      b.textContent = off ? 'Turn the lights on' : 'Turn the lights off';
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-lamp]')) return;
    var off = root.getAttribute('data-lights') === 'off';
    root.setAttribute('data-lights', off ? 'on' : 'off');
    try { localStorage.setItem('diyion-lights', off ? 'on' : 'off'); } catch (err) {}
    paintLamps();
  });

  paintLamps();

  /* ---------------------------------------------------------------- drawer */
  var drawer = $('#drawer');
  var scrim = $('#scrim');
  var burger = $('#burger');
  var drawerX = $('#drawerX');
  var lastFocus = null;

  var FOCUSABLE =
    'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function openDrawer() {
    if (!drawer) return;
    // iOS Safari does not focus a <button> on tap, so activeElement is <body>
    // at open and closing dropped focus to the top of the page. Fall back to
    // the control that opened the drawer.
    var active = document.activeElement;
    lastFocus = active && active !== document.body ? active : burger;
    if (scrim) scrim.hidden = false;
    drawer.hidden = false;
    drawer.removeAttribute('inert');
    document.body.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    if (burger) {
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
    }
    (drawerX || drawer).focus();
  }

  function closeDrawer() {
    if (!drawer || !document.body.classList.contains('drawer-open')) return;
    document.body.classList.remove('drawer-open');
    document.body.style.overflow = '';
    drawer.setAttribute('inert', '');
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
    }
    setTimeout(function () {
      if (!document.body.classList.contains('drawer-open')) {
        if (scrim) scrim.hidden = true;
        drawer.hidden = true;
      }
    }, 300);
    var back = lastFocus && lastFocus.isConnected ? lastFocus : burger;
    if (back && back.focus) back.focus();
  }

  if (drawer) {
    drawer.setAttribute('inert', '');
    on(burger, 'click', openDrawer);
    on(drawerX, 'click', closeDrawer);
    on(scrim, 'click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (!document.body.classList.contains('drawer-open')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, drawer).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ----------------------------------------------------------- accordions */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.macc__hd');
    if (!head) return;
    var acc = head.closest('.macc');
    if (!acc) return;
    var open = acc.classList.toggle('on');
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* -------------------------------------------------------------- gallery */
  var gal = $('#gal');
  if (gal) {
    var galMain = $('#galMain');
    var galImg = $('#galImg');

    var showThumb = function (t) {
      if (!t) return;
      $$('.thumb', gal).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
      gal.setAttribute('data-view', t.dataset.view || 'photo');
      if (galMain) {
        galMain.classList.remove('zoom-2', 'zoom-3', 'zoom-4');
        if (t.dataset.zoom) galMain.classList.add(t.dataset.zoom);
      }
      var src = t.dataset.full || (t.querySelector('img') && t.querySelector('img').src);
      if (galImg && src && t.dataset.view !== 'scale') {
        galImg.src = src;
        var inner = t.querySelector('img');
        if (inner && inner.alt) galImg.alt = inner.alt;
      }
    };

    gal.addEventListener('click', function (e) {
      var t = e.target.closest('.thumb');
      if (t) { e.preventDefault(); showThumb(t); }
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-scale]');
      if (!link) return;
      e.preventDefault();
      var t = $('.thumb[data-view="scale"]', gal);
      if (!t) return;
      showThumb(t);
      gal.scrollIntoView({ behavior: 'smooth', block: 'start' });
      t.focus();
    });

    /* mobile swipe: keep the dots and the label in step with the scroll */
    var track = $('#swipeTrack');
    var dots = $('#galDots');
    var lbl = $('#galLbl');
    if (track) {
      var slides = $$('img, .gal__scale', track);
      var mark = function () {
        if (!slides.length || !track.clientWidth) return;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (dots) {
          $$('.dot', dots).forEach(function (d, n) {
            d.classList.toggle('on', n === i);
            d.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
        }
        if (lbl) lbl.textContent = i + 1 + ' / ' + slides.length;
      };
      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { ticking = false; mark(); });
        },
        { passive: true }
      );
      if (dots) {
        dots.addEventListener('click', function (e) {
          var d = e.target.closest('.dot');
          if (!d) return;
          var n = $$('.dot', dots).indexOf(d);
          track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
        });
      }
      mark();
    }
  }

  /* --------------------------------------------------- sticky buy bar */
  var sticky = $('#sticky');
  if (sticky && document.body.classList.contains('template-product')) {
    var anchor = $('#atc') || $('[data-atc]');
    var setSticky = function (show) {
      sticky.classList.toggle('on', show);
      if (show) sticky.removeAttribute('inert');
      else sticky.setAttribute('inert', '');
    };
    setSticky(false);

    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) { setSticky(!en.isIntersecting && en.boundingClientRect.top < 0); });
        },
        { threshold: 0 }
      ).observe(anchor);
    }
  } else if (sticky) {
    sticky.setAttribute('inert', '');
    sticky.classList.remove('on');
  }

  /* ------------------------------------------------------- review filters */
  var revFilters = $('.rev__filters');
  if (revFilters) {
    revFilters.addEventListener('click', function (e) {
      var chip = e.target.closest('.chip');
      if (!chip) return;
      $$('.chip', revFilters).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');

      var mode = chip.dataset.filter || 'all';
      var shown = 0;
      $$('.rvw').forEach(function (card) {
        var keep =
          mode === 'all' ||
          (mode === 'photos' && card.dataset.photos === '1') ||
          (mode === 'verified' && card.dataset.verified === '1') ||
          (mode === 'critical' && Number(card.dataset.stars || 5) <= 3);
        card.hidden = !keep;
        if (keep) shown++;
      });
      var count = $('#revCount');
      if (count) count.textContent = shown;
    });
  }

  /* --------------------------------------------------- write a review */
  var writeBtn = $('#writeReview');
  var writeForm = $('#wrvForm');
  if (writeBtn && writeForm) {
    on(writeBtn, 'click', function () {
      var open = writeForm.hasAttribute('hidden');
      if (open) writeForm.removeAttribute('hidden');
      else writeForm.setAttribute('hidden', '');
      writeBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var f = writeForm.querySelector(FOCUSABLE);
        if (f) f.focus();
      }
    });
  }
})();

/* ---- _extra-collection.js ---- */
/* ---------------------------------------------------------------------------
   Collection and search browsing.

   The markup already works with JavaScript switched off: filters and sorting
   are plain GET forms, pagination is plain <a href>. This file is pure
   enhancement — it turns the filter panel into a bottom sheet on phones and
   swaps results in place with Shopify's Section Rendering API. If anything
   fails it falls back to a normal page load.
   Appended by theme-build.mjs so it survives a rebuild.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var bound = false;
  var lastFocus = null;
  var timers = new WeakMap();

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function rootOf(el) {
    return el && el.closest ? el.closest('[data-dy-results]') : null;
  }

  function parts(root) {
    return {
      side: root.querySelector('[data-dy-sheet]'),
      scrim: root.querySelector('[data-dy-sheet-scrim]'),
      opener: root.querySelector('[data-dy-sheet-open]'),
    };
  }

  /* ---------- progressive enhancement markers ---------- */

  function enhance(root) {
    var nojs = root.querySelectorAll('[data-dy-nojs]');
    for (var i = 0; i < nojs.length; i++) nojs[i].hidden = true;

    var p = parts(root);
    if (!p.side) return;
    root.setAttribute('data-dy-filters', 'sheet');
    if (p.opener) p.opener.hidden = false;
    var closer = p.side.querySelector('[data-dy-sheet-close]');
    if (closer) closer.hidden = false;
  }

  /* ---------- bottom sheet ---------- */

  function openSheet(root, moveFocus) {
    var p = parts(root);
    if (!p.side) return;
    p.side.setAttribute('data-open', 'true');
    p.side.setAttribute('role', 'dialog');
    p.side.setAttribute('aria-modal', 'true');
    if (p.scrim) p.scrim.setAttribute('data-open', 'true');
    if (p.opener) p.opener.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (moveFocus) {
      lastFocus = document.activeElement;
      var first = p.side.querySelector('[data-dy-sheet-close]');
      if (first && first.focus) first.focus();
    }
  }

  function closeSheet(root) {
    if (!root) return;
    var p = parts(root);
    if (!p.side || !p.side.hasAttribute('data-open')) return;
    p.side.removeAttribute('data-open');
    p.side.removeAttribute('role');
    p.side.removeAttribute('aria-modal');
    if (p.scrim) p.scrim.removeAttribute('data-open');
    if (p.opener) p.opener.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  function trapTab(e) {
    var side = document.querySelector('[data-dy-sheet][data-open="true"]');
    if (!side) return;
    var f = side.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,summary,[tabindex]:not([tabindex="-1"])');
    var list = [];
    for (var i = 0; i < f.length; i++) {
      if (f[i].offsetParent !== null || f[i] === document.activeElement) list.push(f[i]);
    }
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---------- in-place results ---------- */

  function formUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value === null || String(value) === '') return;
      params.append(key, value);
    });
    var qs = params.toString();
    return (form.getAttribute('action') || window.location.pathname) + (qs ? '?' + qs : '');
  }

  function navigate(root, href, opts) {
    opts = opts || {};
    var target;
    try {
      target = new URL(href, window.location.origin);
    } catch (err) {
      window.location.href = href;
      return;
    }

    var id = root.getAttribute('data-dy-results');
    var fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('section_id', id);

    root.setAttribute('aria-busy', 'true');

    fetch(fetchUrl.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-dy-results]');
        if (!next) throw new Error('no results block');

        var wasOpen = !!root.querySelector('[data-dy-sheet][data-open="true"]');
        root.innerHTML = next.innerHTML;
        root.removeAttribute('aria-busy');
        enhance(root);

        if (wasOpen) {
          openSheet(root, false);
        } else {
          document.body.style.overflow = '';
        }

        if (opts.push !== false) {
          window.history.pushState({ dy: true }, '', target.href);
        }

        if (opts.scroll) {
          var top = root.getBoundingClientRect().top + window.pageYOffset - 12;
          window.scrollTo({ top: top < 0 ? 0 : top, behavior: reduced() ? 'auto' : 'smooth' });
        }
      })
      .catch(function () {
        window.location.href = target.href;
      });
  }

  function schedule(root, form) {
    var t = timers.get(form);
    if (t) clearTimeout(t);
    timers.set(
      form,
      setTimeout(function () {
        navigate(root, formUrl(form));
      }, 260)
    );
  }

  /* ---------- events ---------- */

  function bind() {
    if (bound) return;
    bound = true;

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var opener = t.closest('[data-dy-sheet-open]');
      if (opener) {
        var r1 = rootOf(opener);
        if (r1) {
          e.preventDefault();
          openSheet(r1, true);
        }
        return;
      }

      var closer = t.closest('[data-dy-sheet-close]');
      if (closer) {
        var r2 = rootOf(closer);
        if (r2) {
          e.preventDefault();
          closeSheet(r2);
        }
        return;
      }

      var scrim = t.closest('[data-dy-sheet-scrim]');
      if (scrim) {
        closeSheet(rootOf(scrim));
        return;
      }

      var link = t.closest('a[href]');
      if (!link) return;
      var isFacetLink = link.hasAttribute('data-dy-link');
      var isPageLink = link.classList.contains('pg__l');
      if (!isFacetLink && !isPageLink) return;

      var r3 = rootOf(link);
      if (!r3) return;
      if (link.target || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

      e.preventDefault();
      if (isFacetLink) closeSheet(r3);
      navigate(r3, link.href, { scroll: isPageLink });
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var sel = t.closest('[data-dy-sort]');
      if (sel && sel.form) {
        var r1 = rootOf(sel);
        if (r1) navigate(r1, formUrl(sel.form));
        return;
      }

      var form = t.closest('[data-dy-facets]');
      if (form) {
        var r2 = rootOf(form);
        if (r2) schedule(r2, form);
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.hasAttribute) return;
      if (!form.hasAttribute('data-dy-facets') && !form.hasAttribute('data-dy-sort-form')) return;
      var r = rootOf(form);
      if (!r) return;
      e.preventDefault();
      closeSheet(r);
      navigate(r, formUrl(form), { scroll: true });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = document.querySelector('[data-dy-sheet][data-open="true"]');
        if (open) closeSheet(rootOf(open));
        return;
      }
      if (e.key === 'Tab') trapTab(e);
    });

    window.addEventListener('popstate', function () {
      if (!window.history.state || !window.history.state.dy) return;
      var roots = document.querySelectorAll('[data-dy-results]');
      for (var i = 0; i < roots.length; i++) {
        navigate(roots[i], window.location.href, { push: false });
      }
    });

    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1000px)');
      var onWide = function () {
        if (!mq.matches) return;
        var open = document.querySelector('[data-dy-sheet][data-open="true"]');
        if (open) closeSheet(rootOf(open));
      };
      if (mq.addEventListener) mq.addEventListener('change', onWide);
      else if (mq.addListener) mq.addListener(onWide);
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-dy-results]');
    if (!roots.length) return;
    for (var i = 0; i < roots.length; i++) enhance(roots[i]);
    try {
      window.history.replaceState({ dy: true }, '', window.location.href);
    } catch (err) {
      /* history unavailable — plain links still work */
    }
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- _theme-extra-cart.js ---- */
/* ---------------------------------------------------------------------------
   Real add-to-cart. The prototype's version only incremented a counter on the
   page; this one actually posts to Shopify, updates the header count and the
   free-shipping meter, and falls back to a normal form submit when anything
   goes wrong. Delegated, so it works for markup rendered by any section.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var routes = window.routes || {};
  var ADD = routes.cart_add_url || '/cart/add';
  var CART = routes.cart_url || '/cart';

  function formatMoney(cents) {
    var fmt = (window.DIYION && window.DIYION.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var joined = parts.join('.');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, joined)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, joined.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  }

  function paintCount(count) {
    var badge = document.querySelector('.cart b');
    var link = document.querySelector('.cart');
    if (badge) {
      badge.textContent = count;
      if (count > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    }
    /* "1 items" is wrong, and a screen reader reads the label verbatim. */
    if (link) link.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));

    /* The mobile menu carries its own "Cart (n)" button. It is rendered once by
       Liquid and was never repainted, so on a phone you could add a kit, open
       the menu, and be told the cart was empty — during the buying flow, on the
       surface people actually use to navigate. It corrected itself only on the
       next page load, which hid it from any test that reloaded between steps. */
    var drawer = document.querySelector('[data-cart-count-text]');
    if (drawer) drawer.textContent = 'Cart (' + count + ')';
  }

  function paintShipping(totalCents) {
    var threshold = (window.DIYION && window.DIYION.freeShippingThreshold) || 0;
    var wrap = document.getElementById('ship');
    if (!threshold || !wrap) return;
    var bar = document.getElementById('shipBar');
    var lbl = document.getElementById('shipLbl');
    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));

    // The stylesheet animates `width`, not a custom property. Setting --p left
    // the bar frozen at zero however full the cart got.
    if (bar) bar.style.width = pct + '%';

    wrap.classList.toggle('ship--done', totalCents >= threshold);

    // Wording is owned by the product/cart section so the two never disagree
    // mid-page; only fill it in if the section has not already written it.
    if (lbl && !lbl.dataset.owned) {
      lbl.textContent =
        totalCents >= threshold
          ? 'Free shipping unlocked'
          : formatMoney(threshold - totalCents) + ' to free shipping';
    }
  }

  function refresh() {
    fetch(CART + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        paintCount(cart.item_count);
        paintShipping(cart.total_price);
      })
      .catch(function () {});
  }

  function flash(btn, text) {
    if (!btn) return;
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    var prev = btn.innerHTML;
    btn.innerHTML = text;
    setTimeout(function () {
      btn.innerHTML = prev;
      btn.dataset.busy = '';
    }, 1800);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (!window.fetch) return; // no JS cart support — let the browser post normally

    // A section can own its own add-to-cart (the product page does, because it
    // handles the button state, the sticky bar and its own error fallback).
    // Its listener sits on the form and calls preventDefault, but the event
    // still bubbles to here — so this handler was posting a SECOND time and
    // every product landed in the cart twice. Yield, and just resync the
    // header count and the shipping meter once the owner's request lands.
    if (e.defaultPrevented) {
      setTimeout(refresh, 900);
      setTimeout(refresh, 2400);
      return;
    }

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    fetch(ADD + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('aria-busy');
        if (!res.ok) {
          flash(btn, (res.body && res.body.description) || 'Could not add');
          return;
        }
        flash(btn, 'Added to cart');
        refresh();
        document.dispatchEvent(new CustomEvent('diyion:cart:added', { detail: res.body }));
      })
      .catch(function () {
        if (btn) btn.removeAttribute('aria-busy');
        form.submit(); // hard fallback: never lose the sale to a network blip
      });
  });

  // Seed from the state Liquid rendered, so the count is right before any fetch.
  try {
    var seed = document.getElementById('diyion-cart-state');
    if (seed) {
      var s = JSON.parse(seed.textContent);
      paintCount(s.item_count);
      paintShipping(s.total_price);
    }
  } catch (e) {}
})();

/* ---- _theme-extra-chat.js ---- */
/* ---------------------------------------------------------------------------
   Shopify Inbox chat — restyled to match the theme.

   The widget ships as <shopify-chat>, a custom element that paints a
   translucent white pill in Montserrat. On the dark hero it reads as a grey
   smudge sitting on top of the headline, and it belongs to no design system on
   this site.

   WHY THIS IS POSSIBLE AT ALL. Its shadow root is open, so a stylesheet can be
   adopted into it. And because custom properties inherit through the shadow
   boundary, the widget can be dressed in the theme's own tokens — which means
   it follows the lights toggle for free, with no second palette to maintain
   and nothing to keep in sync.

   adoptedStyleSheets rather than an injected <style>: the widget re-renders its
   own subtree when the conversation opens and closes, and an appended element
   would be swept away with it. An adopted sheet is attached to the root, not to
   the markup, so it survives. Where the API is missing the <style> fallback is
   re-applied by the same observer that handles a replaced element.

   Nothing here changes what the widget does. Only how it looks.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CSS = [
    /* Position is set on the launcher's own wrapper, not on the host.

       The widget writes `bottom` straight onto .activator-nudge as an inline
       style from its script — it was resolving to 148px, which parked the pill
       halfway up the screen on top of the hero headline. Host padding cannot
       correct that: the wrapper is absolutely positioned, so it resolves
       against the host's padding box and ignores the padding entirely. A rule
       carrying !important is the one thing that outranks an inline style, so
       the offsets are declared here and the widget's own guess is discarded.

       env() keeps it clear of the home indicator, and --dy-chat-lift is raised
       by the product page so the pill never covers the sticky buy bar. */
    '.activator-nudge {',
    '  position: fixed !important;',
    '  top: auto !important;',
    '  left: auto !important;',
    '  right: max(16px, env(safe-area-inset-right)) !important;',
    '  bottom: calc(16px + env(safe-area-inset-bottom) + var(--dy-chat-lift, 0px)) !important;',
    /* Stands down while the cookie banner is up — see the watcher below. Driven
       by custom properties because a stylesheet inside the shadow root cannot
       see a class on <html>. Keywords are legal custom-property values. */
    '  visibility: var(--dy-chat-vis, visible) !important;',
    '  pointer-events: var(--dy-chat-pe, auto) !important;',
    '}',

    /* ---- the launcher -------------------------------------------------- */
    '.activator {',
    '  background: var(--card, #fff) !important;',
    '  color: var(--text, #15120E) !important;',
    '  border: 1px solid var(--dy-chat-border, #E3DDD1) !important;',
    '  border-radius: 999px !important;',
    '  min-height: 48px !important;',
    '  padding: 0 18px !important;',
    '  gap: 9px !important;',
    '  font-family: "Instrument Sans", system-ui, -apple-system, "Segoe UI", sans-serif !important;',
    '  font-size: 15px !important;',
    '  font-weight: 600 !important;',
    '  letter-spacing: -0.005em !important;',
    /* Two shadows: a tight one to seat the pill against the page, a wide soft
       one to lift it off whatever it happens to be floating over. Lights off
       adds a third — see the token definitions in _theme-extra-chat.css. */
    '  box-shadow: var(--dy-chat-shadow, 0 1px 2px rgba(21, 18, 14, .06), 0 10px 24px rgba(21, 18, 14, .13)) !important;',
    '  transition: transform .18s cubic-bezier(.4, 0, .2, 1),',
    '              box-shadow .18s cubic-bezier(.4, 0, .2, 1),',
    '              border-color .18s !important;',
    '}',

    '.activator:hover {',
    '  transform: translateY(-2px) !important;',
    '  border-color: var(--filament, #FFB25C) !important;',
    '  box-shadow: var(--dy-chat-shadow-hover, 0 2px 4px rgba(21, 18, 14, .07), 0 16px 34px rgba(21, 18, 14, .17)) !important;',
    '}',

    '.activator:active { transform: translateY(0) !important; }',

    /* The widget's own focus ring is a browser default. Match the theme's. */
    '.activator:focus-visible {',
    '  outline: 2px solid var(--focus, #2A27E6) !important;',
    '  outline-offset: 3px !important;',
    '}',

    /* The one spot of brand colour. The label stays in text colour so the
       control still reads as a utility rather than competing with Add to cart. */
    '.activator__icon { color: var(--filament, #FFB25C) !important; }',
    '.activator__icon svg { width: 18px !important; height: 18px !important; }',

    /* Unread badge — amber on the surface colour so it reads as ours, and a
       ring so it stays visible against the pill it sits on. */
    '.activator__indicator {',
    '  background: var(--filament, #FFB25C) !important;',
    '  box-shadow: 0 0 0 2px var(--card, #fff) !important;',
    '}',

    /* The conversation panel is deliberately not styled here. It renders inside
       <shopify-agent-runtime>, a nested custom element with its own shadow
       root, and CSS does not cascade across a second shadow boundary — only
       inherited properties and custom properties do, and it reads neither. An
       earlier version of this file carried .chat-window / .chat-container
       rules; those class names do not exist in the widget and matched nothing.
       The launcher is the part that is ours to fix, and it is the part a
       visitor looks at until the moment they open a conversation. */

    '@media (prefers-reduced-motion: reduce) {',
    '  .activator { transition: none !important; }',
    '  .activator:hover { transform: none !important; }',
    '}'
  ].join('\n');

  var sheet = null;

  function styleSheetFor() {
    if (sheet !== null) return sheet;
    try {
      if (typeof CSSStyleSheet === 'function' && 'replaceSync' in CSSStyleSheet.prototype) {
        sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
        return sheet;
      }
    } catch (err) { /* fall through to the <style> path */ }
    sheet = false;
    return sheet;
  }

  function dress(el) {
    var root = el && el.shadowRoot;
    if (!root) return false;

    var adopted = styleSheetFor();

    if (adopted) {
      if (root.adoptedStyleSheets && root.adoptedStyleSheets.indexOf(adopted) !== -1) return true;
      try {
        /* Concat rather than push: adoptedStyleSheets is a frozen array in
           older implementations and push throws there. */
        root.adoptedStyleSheets = (root.adoptedStyleSheets || []).concat(adopted);
        return true;
      } catch (err) { /* fall through */ }
    }

    if (root.querySelector('style[data-dy-chat]')) return true;
    var tag = document.createElement('style');
    tag.setAttribute('data-dy-chat', '');
    tag.textContent = CSS;
    root.appendChild(tag);
    return true;
  }

  /* ---- stand down while the consent banner is up ------------------------
     The widget mounts at z-index 2147483000; Shopify's cookie banner sits at
     2000000. So the launcher painted straight over the banner — a floating
     button on top of a consent dialog the visitor is legally entitled to
     answer first, and on a 390px screen it landed inside the banner's box.

     The email popup already waits for the banner to be dismissed. The chat
     now waits too, so the bottom-right corner never has two things fighting
     for it. Visibility rather than display: the widget measures itself on
     mount, and removing it from layout mid-measure made it re-run its own
     positioning. */
  function bannerOpen() {
    var el = document.getElementById('shopify-pc__banner');
    return !!el && el.offsetHeight > 0;
  }

  function syncConsent() {
    var open = bannerOpen();
    var root = document.documentElement;
    if (open === (root.getAttribute('data-dy-consent') === 'open')) return;
    if (open) root.setAttribute('data-dy-consent', 'open');
    else root.removeAttribute('data-dy-consent');
  }

  function watchConsent() {
    syncConsent();
    document.addEventListener('visitorConsentCollected', syncConsent);
    /* Shopify injects and removes the banner without notice, so the element
       has to be watched rather than checked once. Bounded to the first
       stretch of the visit: after that the choice is made and stored. */
    var n = 0;
    var t = setInterval(function () {
      syncConsent();
      if (++n > 40 && !bannerOpen()) clearInterval(t);
    }, 500);
    if (window.MutationObserver) {
      new MutationObserver(syncConsent).observe(document.body, { childList: true, subtree: false });
    }
  }

  function find() {
    return document.querySelector('shopify-chat');
  }

  function attempt() {
    var el = find();
    return el ? dress(el) : false;
  }

  /* The app embed injects the element well after load, and the shadow root can
     arrive a tick after the element. A bounded poll covers both without leaving
     a timer running for the whole visit. */
  var tries = 0;
  var poll = setInterval(function () {
    if (attempt() || ++tries > 60) clearInterval(poll);
  }, 500);

  /* If the app ever swaps the element out, re-dress the replacement. Watching
     only direct children of <body> keeps this cheap — that is where the widget
     mounts. */
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && n.tagName === 'SHOPIFY-CHAT') dress(n);
        }
      }
    }).observe(document.body, { childList: true });
  }

  watchConsent();
  attempt();
})();

/* ---- _theme-extra-content.js ---- */
/* ---------------------------------------------------------------------------
   Content pages.

   Only one thing here needs JavaScript: the policy route.

   /policies/* is rendered by Shopify itself, not by the theme. There is no
   section and no template — `templates/policy.json` is rejected by the Theme
   API ("Template type 'policy' does not support JSON templates") and a
   `templates/policy.liquid` uploads but is never used. Shopify emits a fixed
   block into content_for_layout and that is all a theme gets.

   So the styling lives in CSS (_theme-extra-content.css) and works with
   JavaScript switched off. This file is pure enhancement on top of it: it
   marks the container as design-system markup and adds the two navigation
   pieces the platform never renders — a breadcrumb, and links to the store's
   other policies so a reader is not dead-ended at the bottom of 4,000px of
   legal text.

   Nothing here removes text. The policy body is moved, never rewritten.
--------------------------------------------------------------------------- */
/* ---- form outcomes ---------------------------------------------------------
   Shopify's contact and comment forms POST and reload. That means the "message
   received" / "that did not send" block is already in the document when the
   page starts, so an aria-live region announces nothing at all and a sighted
   keyboard user is returned to the top of the page with no idea whether the
   thing sent. Moving focus onto the message is what actually reports the
   outcome; the element carries tabindex="-1" for exactly this. With JavaScript
   off the form's own anchor still puts the message on screen, so nothing here
   is load-bearing.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var msg = document.querySelector('[data-dy-focus]');
  if (!msg) return;
  /* Wait a frame: focusing during parse fights the browser's own restoration
     of the scroll position and the message can end up scrolled off screen. */
  requestAnimationFrame(function () {
    try {
      msg.focus({ preventScroll: true });
      msg.scrollIntoView({ block: 'center', behavior: 'auto' });
    } catch (err) { /* focus is a nicety, never a requirement */ }
  });
})();

(function () {
  'use strict';

  var box = document.querySelector('.shopify-policy__container');
  if (!box || box.classList.contains('dy')) return;

  var title = box.querySelector('.shopify-policy__title');
  var body = box.querySelector('.shopify-policy__body');
  var h1 = title && title.querySelector('h1');

  /* The design system's stylesheet is namespaced under .dy. Adding the wrapper
     class here lets the breadcrumb and the link list below pick up the store's
     own styling instead of needing a second copy of it. */
  box.classList.add('dy', 'dy-policy');

  /* Shopify wraps the copy in Dawn's .rte. Nothing in _theme-extra-content.css
     keys off that class, and leaving it lets base.css keep fighting for the
     typography, so drop it. The text itself is untouched. */
  if (body) {
    var rte = body.querySelector('.rte');
    if (rte) {
      rte.classList.remove('rte');
      rte.classList.add('dy-policy__body');
    }
    /* A pasted <table> wider than the phone must scroll inside its own box. */
    var tables = body.querySelectorAll('table');
    for (var t = 0; t < tables.length; t++) {
      var tb = tables[t];
      if (tb.parentNode && tb.parentNode.classList.contains('dy-policy__scroll')) continue;
      var scroll = document.createElement('div');
      scroll.className = 'dy-policy__scroll';
      tb.parentNode.insertBefore(scroll, tb);
      scroll.appendChild(tb);
    }
  }

  /* ---- breadcrumb ---------------------------------------------------------
     Home / <policy title>. Matches sections/dy-page.liquid exactly, so the
     policy route reads like every other content page. */
  if (title && h1) {
    var crumb = document.createElement('nav');
    crumb.className = 'crumb dy-policy__hd';
    crumb.setAttribute('aria-label', 'Breadcrumb');

    var home = document.createElement('a');
    home.href = '/';
    home.textContent = 'Home';
    crumb.appendChild(home);

    var sep = document.createElement('span');
    sep.setAttribute('aria-hidden', 'true');
    sep.textContent = '/';
    crumb.appendChild(sep);

    var here = document.createElement('span');
    here.setAttribute('aria-current', 'page');
    here.textContent = (h1.textContent || '').trim();
    crumb.appendChild(here);

    box.insertBefore(crumb, title);
  }

  /* ---- the other policies -------------------------------------------------
     Read from the footer that is already on the page, so this invents no URLs
     and no titles: if the shop has not published a policy, no link appears.
     Falls back to nothing rather than to a guess. */
  var links = [];
  var seen = {};
  var hereHref = window.location.pathname.replace(/\/+$/, '');
  var footLinks = document.querySelectorAll('.dy-footer a[href*="/policies/"]');

  for (var i = 0; i < footLinks.length; i++) {
    var a = footLinks[i];
    var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/+$/, '');
    var text = (a.textContent || '').trim();
    if (!href || !text) continue;
    if (href === hereHref) continue;
    if (seen[href]) continue;
    seen[href] = 1;
    links.push({ href: href, text: text });
  }

  if (links.length) {
    var foot = document.createElement('div');
    foot.className = 'dy-policy__foot';

    var rule = document.createElement('hr');
    rule.className = 'rule';
    foot.appendChild(rule);

    var head = document.createElement('h2');
    head.textContent = 'The rest of the small print';
    foot.appendChild(head);

    var list = document.createElement('ul');
    list.className = 'lnks';
    for (var j = 0; j < links.length; j++) {
      var li = document.createElement('li');
      var la = document.createElement('a');
      la.href = links[j].href;
      la.textContent = links[j].text;
      li.appendChild(la);
      list.appendChild(li);
    }
    foot.appendChild(list);
    box.appendChild(foot);
  }
})();

/* ---- _theme-extra-footer.js ---- */
/* ---------------------------------------------------------------------------
   Footer behaviour.

   1. Link columns. The markup ships <details open>, so with JavaScript off every
      link is visible and crawlable. sections/dy-footer.liquid carries a tiny
      inline script that closes them while the footer is still parsing, so they
      never paint open and then snap shut. This file owns everything after that:
      reopening when the viewport grows, and leaving alone a column the reader
      opened themselves.

   The country / language picker is NOT here. The footer renders the same
   snippet as the header bar and the mobile menu, so _theme-extra-header.js
   wires all three in one place; a second copy here drifted from it.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var MQ = '(max-width: 767px)';
  if (!window.matchMedia) return;

  var mq = window.matchMedia(MQ);

  function cols() {
    return document.querySelectorAll('.dy .ftr__col');
  }

  function apply() {
    var list = cols();
    if (!list.length) return;
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (mq.matches) {
        // Leave a column the reader opened themselves alone.
        if (el.dataset.userToggled === '1') continue;
        el.open = false;
      } else {
        el.open = true;
      }
    }
  }

  // Keyed off the click, not the toggle event: setting `open` in code also fires
  // `toggle`, which would have marked every column as reader-opened on load.
  // Above the phone breakpoint the columns are laid out as plain lists, so the
  // summary must not collapse them — keyboard Enter and Space arrive as clicks
  // too, so one handler covers both.
  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('.ftr__col > summary');
    if (!summary) return;
    if (mq.matches) summary.parentNode.dataset.userToggled = '1';
    else e.preventDefault();
  }, true);

  apply();

  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();

/* ---- _theme-extra-header.js ---- */
/* ---------------------------------------------------------------------------
   Header behaviour.

   Everything here is an enhancement. With JavaScript off the header still
   works: the menu panels open on hover and focus in CSS, the magnifier is a
   real link to the search page, the search form is a plain GET, and the
   country picker keeps a submit button inside <noscript>.

   Owns: pinned-bar shadow, the search reveal, predictive suggestions, panel
   aria state, and auto-submit for the localization form.
   Does NOT own: the drawer, the lights toggle or the cart bubble — those are
   bound in _core.js and _theme-extra-cart.js.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };

  /* -------------------------------------------------------- localization */
  /* The same picker renders in the utility bar, the mobile menu and the
     footer. Wired here, document-wide and before the header guard below, so
     all three behave identically and no second copy of this exists in the
     footer script. Country and language sit in one form, so a visitor who
     changes both reloads once. With JavaScript off the form keeps its submit
     button inside <noscript> and works unchanged. */
  $$('form.loc').forEach(function (form) {
    $$('[data-loc-select]', form).forEach(function (select) {
      on(select, 'change', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    });
  });

  var header = document.querySelector('.dy-header');
  if (!header) return;

  /* ------------------------------------------------------------ pinned bar */
  /* The bar cannot observe itself while it is stuck, so a zero-height marker
     above it is watched instead. No scroll listener, no layout thrash. */
  var bar = $('.nav', header);
  var mark = $('.nav__mark', header);
  if (bar && mark && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-stuck', !en.isIntersecting); });
      },
      { threshold: 0 }
    ).observe(mark);
  }

  /* --------------------------------------------------------- search reveal */
  var toggle = $('[data-q-toggle]', header);
  var barForm = bar ? $('.hq', bar) : null;
  var barInput = barForm ? $('[data-hq-input]', barForm) : null;

  function setSearch(open) {
    header.classList.toggle('q-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && barInput) barInput.focus();
  }

  if (toggle && barForm) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', barForm.id || 'header-search');
    on(toggle, 'click', function (e) {
      // Only intercept while the field is hidden behind the icon. Above
      // 1180px the field is always in the bar and the icon is not rendered.
      if (getComputedStyle(toggle).display === 'none') return;
      e.preventDefault();
      setSearch(!header.classList.contains('q-open'));
    });
    on(document, 'click', function (e) {
      if (!header.classList.contains('q-open')) return;
      if (barForm.contains(e.target) || toggle.contains(e.target)) return;
      setSearch(false);
    });
  }

  /* --------------------------------------------------- predictive suggests */
  /* Products come from Shopify's own suggestion endpoint, so every row is a
     real product in this shop. Prices are the amounts Shopify returned for the
     visitor's active currency; if that currency is unknown the price is left
     out rather than guessed. */
  function money(value, currency) {
    var n = Number(value);
    if (!currency || !isFinite(n)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      }).format(n);
    } catch (err) {
      return '';
    }
  }

  /* A product whose variants span a range must not be labelled with its
     cheapest variant as though that were the price. */
  function priceLabel(p, currency) {
    var lo = p.price_min != null ? p.price_min : p.price;
    var hi = p.price_max != null ? p.price_max : p.price;
    var text = money(lo, currency);
    if (!text) return '';
    if (Number(hi) > Number(lo)) return 'From ' + text;
    return text;
  }

  function thumb(url) {
    if (!url) return null;
    var img = document.createElement('img');
    img.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
    img.width = 42;
    img.height = 42;
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    return img;
  }

  function row(id, href, title, imageUrl, price) {
    var a = document.createElement('a');
    a.className = 'hq__r';
    a.id = id;
    a.href = href;
    a.setAttribute('role', 'option');
    a.setAttribute('aria-selected', 'false');
    var im = thumb(imageUrl);
    if (im) a.appendChild(im);
    var t = document.createElement('span');
    t.className = 'hq__rt';
    t.textContent = title;
    a.appendChild(t);
    if (price) {
      var p = document.createElement('span');
      p.className = 'hq__rp';
      p.textContent = price;
      a.appendChild(p);
    }
    return a;
  }

  function heading(text) {
    var p = document.createElement('p');
    p.className = 'hq__h';
    p.textContent = text;
    return p;
  }

  

  /* The predictive dropdown now lives in _theme-extra-search.js, bound from
     snippets/dy-header-search.liquid. The old wireSuggest path was removed. */

  /* ------------------------------------------------------------- key: Esc  */
  on(document, 'keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (header.classList.contains('q-open')) {
      setSearch(false);
      if (toggle) toggle.focus();
    }
    var open = $$('.dd', header).filter(function (dd) {
      var t = $('[data-dd-t]', dd);
      return t && t.getAttribute('aria-expanded') === 'true';
    });
    open.forEach(function (dd) {
      var t = $('[data-dd-t]', dd);
      /* Closing the panel makes it `visibility: hidden`, which un-focuses
         whatever link inside it the reader had reached — focus fell all the way
         back to <body>, so the next Tab restarted at the top of the page. Put
         it on the trigger first, which is where Escape should leave it anyway.
         The trigger is inside .dd, so the focusout handler treats this as
         staying put and the panel remains closed. */
      if (t && dd.contains(document.activeElement) && document.activeElement !== t) {
        t.focus();
      }
      dd.setAttribute('data-dd-closed', '');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  /* ------------------------------------------------------------ nav panels */
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  $$('.dd', header).forEach(function (dd) {
    var trigger = $('[data-dd-t]', dd);
    var panel = $('[data-dd-p]', dd);
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    var state = function (open) {
      if (open) dd.removeAttribute('data-dd-closed');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    on(dd, 'mouseenter', function () { state(true); });
    on(dd, 'mouseleave', function () { state(false); dd.removeAttribute('data-dd-closed'); });
    on(dd, 'focusin', function () { state(true); });
    on(dd, 'focusout', function (e) {
      if (dd.contains(e.relatedTarget)) return;
      state(false);
      dd.removeAttribute('data-dd-closed');
    });

    // Without hover there is nothing to hover: the first tap opens the panel,
    // the second follows the link.
    if (!fine) {
      on(trigger, 'click', function (e) {
        if (trigger.getAttribute('aria-expanded') !== 'true') {
          e.preventDefault();
          state(true);
        }
      });
    }
  });
})();

/* ---- _theme-extra-klaviyo.js ---- */
/* ---------------------------------------------------------------------------
   Klaviyo email capture — footer signup and back-in-stock.

   One file owns every Klaviyo call the storefront makes, so consent semantics
   and error handling cannot drift between capture points.

   PROGRESSIVE ENHANCEMENT. Nothing here is required for a form to work. The
   footer ships a real Shopify {% form 'customer' %} that posts and reloads on
   its own; this script only intercepts it when scripting is available. With
   JavaScript off the Shopify form still captures the address. The back-in-stock
   block has no server-side equivalent, so it hides itself in <noscript> and
   offers a mailto link instead of a form that would do nothing.

   API REVISION — 2025-01-15, not 2024-10-15.
   The client subscriptions endpoint only accepts an explicit consent block
   (`profile.attributes.subscriptions`) from 2025-01-15 onwards. On 2024-10-15
   the same body is rejected with:
       "'subscriptions' is not a valid field for the resource 'profile'"
   and the request succeeds only if the consent block is dropped — which would
   let Klaviyo apply a default consent instead of the one the shopper gave.
   This store sells into the EU, so consent is stated, never implied.

   No private key is used or needed. The company id is Klaviyo's public site id
   and is safe in page source; the private key never leaves the build machine.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var REVISION = '2025-01-15';
  var CLIENT = 'https://a.klaviyo.com/client/';
  var TIMEOUT = 12000;

  /* A deliberately loose check. Its only job is to catch obvious typos before a
     round trip; Klaviyo is the authority on what a deliverable address is, and
     a strict pattern here would reject valid addresses the API accepts. */
  var EMAILISH = /^[^\s@]+@[^\s@.]+\.[^\s@]{2,}$/;

  function isEmail(v) {
    return EMAILISH.test(String(v || '').trim());
  }

  /* ---- transport ---------------------------------------------------------
     Returns a plain outcome string rather than throwing, so every caller
     handles the same small set of states:
       'ok'       accepted
       'invalid'  Klaviyo rejected the address
       'missing'  the variant is not in Klaviyo's catalogue (back-in-stock)
       'busy'     rate limited
       'error'    network failure, timeout, or anything unexpected
  --------------------------------------------------------------------------- */
  function send(endpoint, companyId, body) {
    if (!window.fetch || !companyId) return Promise.resolve('error');

    var controller = null;
    var timer = null;
    if (window.AbortController) {
      controller = new AbortController();
      timer = setTimeout(function () { controller.abort(); }, TIMEOUT);
    }

    return fetch(CLIENT + endpoint + '/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(body),
      signal: controller ? controller.signal : undefined,
      keepalive: true
    })
      .then(function (res) {
        if (timer) clearTimeout(timer);
        if (res.status === 202 || (res.status >= 200 && res.status < 300)) return 'ok';
        if (res.status === 429) return 'busy';
        if (res.status === 400 || res.status === 404) {
          /* Read the body only to tell "bad address" from "unknown variant".
             Anything unparseable is treated as a plain failure. */
          return res.json().then(function (j) {
            var err = (j && j.errors && j.errors[0]) || {};
            if (err.code === 'variant_not_found') return 'missing';
            var pointer = (err.source && err.source.pointer) || '';
            if (pointer.indexOf('email') !== -1) return 'invalid';
            return res.status === 404 ? 'missing' : 'invalid';
          }, function () { return 'error'; });
        }
        return 'error';
      })
      .catch(function () {
        if (timer) clearTimeout(timer);
        return 'error';
      });
  }

  /* ---- public calls ------------------------------------------------------ */

  /* Marketing consent, stated explicitly. SUBSCRIBED is only ever sent when the
     shopper performed an affirmative act on a form that says what they are
     signing up for. Nothing on this storefront subscribes anyone as a side
     effect of another action. */
  function subscribe(opts) {
    return send('subscriptions', opts.companyId, {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: opts.source || 'Storefront',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: opts.email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: opts.listId } } }
      }
    });
  }

  /* Asking to be told when a kit is restocked is a service request, not consent
     to marketing, so this sets no marketing consent at all. The newsletter tick
     box beside it is separate, unticked, and calls subscribe() on its own. */
  function backInStock(opts) {
    return send('back-in-stock-subscriptions', opts.companyId, {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: opts.email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              /* The id Klaviyo's Shopify integration gives a synced variant.
                 A variant it has never seen returns 404 variant_not_found. */
              id: '$shopify:::$default:::' + opts.variantId
            }
          }
        }
      }
    });
  }

  window.dyKlaviyo = { subscribe: subscribe, backInStock: backInStock, isEmail: isEmail };

  /* ---- shared form plumbing ---------------------------------------------- */

  function $(id) { return document.getElementById(id); }

  function show(el, text) {
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
  }

  /* One place decides what the shopper is told. Every string comes from a theme
     setting via data-msg-*, so the merchant can reword or translate it and no
     copy is trapped in this file. */
  function messageFor(host, outcome) {
    var d = host.dataset;
    if (outcome === 'ok') return d.msgOk || '';
    if (outcome === 'already') return d.msgAlready || d.msgOk || '';
    if (outcome === 'invalid') return d.msgInvalid || '';
    if (outcome === 'busy') return d.msgBusy || d.msgError || '';
    if (outcome === 'missing') return d.msgMissing || d.msgError || '';
    return d.msgError || '';
  }

  /* "Already subscribed" is a local fact, never a claim about Klaviyo.
     The client subscriptions endpoint answers 202 for a brand-new profile and
     for one that has been on the list for a year — it deliberately does not
     reveal whether an address is already stored, because that would turn a
     public endpoint into a way to test whether someone shops here. So the only
     honest source for this state is this browser's own history. */
  var STORE = 'dy:klaviyo:subscribed';

  function seen(email) {
    try {
      var raw = window.localStorage.getItem(STORE);
      if (!raw) return false;
      return JSON.parse(raw).indexOf(email.toLowerCase()) !== -1;
    } catch (e) { return false; }
  }

  function remember(email) {
    try {
      var raw = window.localStorage.getItem(STORE);
      var list = raw ? JSON.parse(raw) : [];
      var key = email.toLowerCase();
      if (list.indexOf(key) === -1) list.push(key);
      window.localStorage.setItem(STORE, JSON.stringify(list.slice(-20)));
    } catch (e) { /* private mode — the state is a nicety, not a requirement */ }
  }

  /* Wires whatever carries data-dy-klaviyo. That is the <form> itself where the
     markup is ours, and a wrapping element where it is not: Shopify's
     {% form 'customer' %} tag renders its own <form> and accepts no data-*
     attributes, so the footer's configuration has to live on the element around
     it. Null-safe throughout — a page without the form, or a form missing its
     message elements, must not throw and take the rest of the bundle down. */
  function wire(host) {
    if (!host || host.dataset.dyWired === '1') return;
    var form = host.tagName === 'FORM' ? host : host.querySelector('form');
    if (!form) return;
    host.dataset.dyWired = '1';

    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    var ok = $(host.dataset.okTarget || '');
    var err = $(host.dataset.errTarget || '');
    var optin = $(host.dataset.optinTarget || '');
    var busyLabel = host.dataset.msgSending || '';
    var idle = button ? button.innerHTML : '';

    function settle(outcome) {
      var text = messageFor(host, outcome);
      var good = outcome === 'ok' || outcome === 'already';
      show(good ? ok : err, text);
      show(good ? err : ok, '');
      if (input) {
        if (outcome === 'invalid') input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      }
      if (button) {
        button.disabled = false;
        if (busyLabel) button.innerHTML = idle;
      }
      host.dataset.dyState = outcome;
      if (good) {
        if (input) input.value = '';
        /* Success is terminal: the fields go, the message stays. */
        form.classList.add('is-done');
      } else if (outcome === 'invalid' && input) {
        input.focus();
      }
    }

    form.addEventListener('submit', function (e) {
      /* Always cancelled. The back-in-stock form has no action, so letting a
         submit through would reload the product page with the address sitting
         in the query string and in the reader's history. The footer's Shopify
         action still runs when this script is absent, which is the whole
         no-JavaScript path. */
      e.preventDefault();

      var email = input ? String(input.value || '').trim() : '';

      /* Hand an empty field back to the browser so the shopper gets the
         native "please fill in this field" bubble in their own language. */
      if (!email) {
        if (form.reportValidity) form.reportValidity();
        else if (input) input.focus();
        return;
      }

      if (!isEmail(email)) { settle('invalid'); return; }

      if (seen(email) && !optin) { settle('already'); return; }

      if (button) {
        button.disabled = true;
        if (busyLabel) button.textContent = busyLabel;
      }
      show(err, '');
      show(ok, '');

      var companyId = host.dataset.company;
      var kind = host.dataset.dyKlaviyo;

      var call;
      if (kind === 'back-in-stock') {
        call = backInStock({
          companyId: companyId,
          email: email,
          /* The buy form owns the selected variant; read it at submit time so a
             shopper who switched options is registered for the one on screen. */
          variantId: (($('dyVariantId') || {}).value) || host.dataset.variant
        });
      } else {
        call = subscribe({
          companyId: companyId,
          listId: host.dataset.list,
          email: email,
          source: host.dataset.source || 'Storefront'
        });
      }

      call.then(function (outcome) {
        /* The newsletter tick box beside a back-in-stock form is a second,
           separate consent. It only runs when the shopper ticked it, and its
           failure never changes what they are told about the restock alert. */
        if (outcome === 'ok' && optin && optin.checked && host.dataset.list) {
          subscribe({
            companyId: companyId,
            listId: host.dataset.list,
            email: email,
            source: (host.dataset.source || 'Storefront') + ' — newsletter opt-in'
          });
        }
        if (outcome === 'ok') remember(email);
        settle(outcome);
      });
    });
  }

  function wireAll() {
    var hosts = document.querySelectorAll('[data-dy-klaviyo]');
    for (var i = 0; i < hosts.length; i++) wire(hosts[i]);
  }

  /* ---- back-in-stock visibility on multi-variant products ----------------
     Liquid decides whether the block is shown for the variant the page loaded
     with. After that the buy box script owns availability, so rather than
     duplicating its variant matching — which would drift the first time either
     side changed — this watches the one thing it already maintains: whether
     #atc is disabled and reading "Sold out". An impossible option combination
     disables the button too but reads "Unavailable", and offering a restock
     alert for a variant that does not exist would be a lie, so only the
     sold-out wording opens the block.
  --------------------------------------------------------------------------- */
  function watchAvailability() {
    var block = $('dyBis');
    var atc = $('atc');
    var price = $('atcPrice');
    if (!block || !atc || !price || !window.MutationObserver) return;

    var soldOutWord = (block.dataset.soldOutWord || 'sold out').toLowerCase();

    function sync() {
      var text = String(price.textContent || '').trim().toLowerCase();
      var soldOut = atc.disabled && text.indexOf(soldOutWord) !== -1;
      if (soldOut === !block.hidden) return;
      block.hidden = !soldOut;
      /* A block that is not on screen must not be reachable by keyboard. */
      if (soldOut) block.removeAttribute('inert');
      else block.setAttribute('inert', '');
    }

    new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    new MutationObserver(sync).observe(price, { childList: true, characterData: true, subtree: true });
    sync();
  }

  function init() {
    wireAll();
    watchAvailability();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---------------------------------------------------------------------------
   Klaviyo onsite tracking — Viewed Product and Added to Cart.

   WHY THIS EXISTS. klaviyo.js is loaded on every page by the Klaviyo app
   embed, but loading it tracks nothing on its own. Shopify's integration only
   sends order and checkout events server-side; the two browsing events have to
   be raised by the theme. They never were, so the account recorded 0 Viewed
   Product and 0 Added to Cart events in twelve months, and the browse
   abandonment and abandoned cart flows could not fire even once. Everything
   here exists to give those two flows a real trigger.

   CONSENT FIRST. These are marketing events tied to an identifiable person, so
   nothing is sent until Shopify's privacy API says analytics processing is
   allowed. A visitor who has not answered the banner yet is not tracked, and a
   visitor who declines is never tracked. If consent arrives later in the visit
   the queued page view is released then — that is the only thing the queue is
   for; it is dropped on navigation, never persisted.

   WHAT KLAVIYO DOES WITH THESE. Klaviyo only keeps events for a browser it can
   attach to a profile — someone who has submitted a form here or arrived from
   one of our emails. Anonymous views are discarded at their end by design. So
   these events build coverage over time as the list grows; they are not a
   switch that fills the flows overnight.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* klaviyo.js replaces this array with an object that keeps the same push
     signature, so pushing is safe whether or not the script has loaded yet. */
  function queue() {
    window.klaviyo = window.klaviyo || [];
    return window.klaviyo;
  }

  /* True only on an explicit yes.

     `analyticsProcessingAllowed()` answers false in two completely different
     situations: the visitor declined, and the visitor has not been asked yet.
     Treating those the same is what made the first version of this useless —
     the product view was raised while the cookie banner was still on screen,
     read the false as a refusal, and threw the view away a second before the
     visitor pressed Accept. The banner is on screen for every first-time
     visitor, so that was every first session. Held events are therefore kept
     until the question is actually answered, and only then sent or dropped. */
  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return false;
      return api.analyticsProcessingAllowed() === true;
    } catch (err) {
      return false;
    }
  }

  /* Holds whole klaviyo.push arguments, not just track calls, so that
     trackViewedItem survives the wait on the same terms as everything else.
     Capped, page-scoped, and never written to storage. */
  var pending = [];

  function push(args) {
    if (allowed()) { queue().push(args); return; }
    if (pending.length < 8) pending.push(args);
  }

  function emit(name, payload) {
    if (!name || !payload) return;
    push(['track', name, payload]);
  }

  function release() {
    if (!allowed()) return;
    var held = pending.slice();
    pending.length = 0;
    for (var i = 0; i < held.length; i++) queue().push(held[i]);
  }

  /* Shopify raises this the moment a choice is made, including a decline —
     in which case release() sends nothing and the held events simply expire
     with the page. */
  document.addEventListener('visitorConsentCollected', release);

  /* The privacy API loads asynchronously and announces nothing when it becomes
     available, so a short poll covers the visitor who had already consented on
     an earlier visit: for them no banner appears and no event is ever raised.
     Bounded, because after a few seconds either consent exists or the banner is
     waiting, and the listener above owns that case. */
  var tries = 0;
  var poll = setInterval(function () {
    if (allowed() || ++tries > 20) {
      clearInterval(poll);
      release();
    }
  }, 300);

  /* ---- viewed product --------------------------------------------------- */
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (err) { return null; }
  }

  function viewedProduct() {
    var p = readJSON('dy-track-product');
    if (!p || !p.ProductID) return;

    emit('Viewed Product', p);

    /* trackViewedItem is a separate call with its own shape. It is what feeds
       the "recently viewed" block Klaviyo can drop into an email, and it is
       what browse abandonment reads. Tracking the event alone is not enough. */
    push(['trackViewedItem', {
      Title: p.Name,
      ItemId: p.ProductID,
      Categories: p.Categories,
      ImageUrl: p.ImageURL,
      Url: p.URL,
      Metadata: { Brand: p.Brand, Price: p.Price, CompareAtPrice: p.CompareAtPrice }
    }]);
  }

  /* ---- added to cart ----------------------------------------------------
     The cart module already announces a real, server-confirmed add. Listening
     to that rather than to the button means a failed add is never reported as
     a successful one. */
  document.addEventListener('diyion:cart:added', function (e) {
    var item = e && e.detail;
    if (!item) return;

    /* /cart/add.js answers with the line item; a multi-item add answers with
       { items: [...] }. Report the first either way — the flow needs to know a
       cart exists and what started it, not the full basket. */
    if (item.items && item.items.length) item = item.items[0];
    if (!item.product_id) return;

    emit('Added to Cart', {
      $value: typeof item.final_line_price === 'number' ? item.final_line_price / 100 : undefined,
      AddedItemProductID: String(item.product_id),
      AddedItemProductName: item.product_title || item.title,
      AddedItemSKU: item.sku || undefined,
      AddedItemImageURL: item.image || undefined,
      AddedItemURL: item.url ? location.origin + item.url : undefined,
      AddedItemPrice: typeof item.price === 'number' ? item.price / 100 : undefined,
      AddedItemQuantity: item.quantity
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', viewedProduct);
  else viewedProduct();
})();

/* ---- _theme-extra-motion.js ---- */
/* ---------------------------------------------------------------------------
   Scroll reveal.

   Opt-in by design: the html.dy-motion class is added by this script, so if the
   script never runs, or the reader prefers reduced motion, nothing is hidden.
   Content visibility never depends on JavaScript succeeding.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;

  // Sections worth animating. Deliberately not everything — a page where every
  // element flies in reads as a template, not a brand.
  var SELECTOR = [
    '.dy .band > .wrap > *',
    '.dy .grid',
    '.dy .cats',
    '.dy .steps',
    '.dy .panels',
    '.dy .trust__i',
    '.dy .rung',
  ].join(',');

  var nodes = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  if (!nodes.length) return;

  // Anything already on screen at load stays put — animating it would just be a
  // flash of missing content on first paint.
  var fold = window.innerHeight * 1.05;
  var deferred = nodes.filter(function (el) {
    var r = el.getBoundingClientRect();
    if (r.height === 0) return false;
    return r.top > fold;
  });
  if (!deferred.length) return;

  root.classList.add('dy-motion');
  deferred.forEach(function (el) { el.classList.add('dy-reveal'); });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  deferred.forEach(function (el) { io.observe(el); });

  // Safety net: if anything is still hidden after a few seconds — an observer
  // that never fired, a container that never scrolled — show it.
  setTimeout(function () {
    deferred.forEach(function (el) { el.classList.add('is-in'); });
  }, 6000);
})();

/* ---- _theme-extra-popup.js ---- */
/* ---------------------------------------------------------------------------
   POPUP — email capture, wired to Klaviyo.

   Everything here is an enhancement, and it is the only thing that can reveal
   the dialog: sections/dy-popup.liquid ships the element `hidden` and `inert`,
   and the stylesheet only grants it a display value under `[data-open]`. With
   JavaScript off the popup does not appear, does not reserve space, and is not
   in the accessibility tree.

   Subscribing goes straight from the browser to Klaviyo's client endpoint:

     POST https://a.klaviyo.com/client/subscriptions/?company_id=<site id>
     revision: 2025-01-15

   That endpoint is designed for public site ids. No private key is involved,
   and none may ever be put in theme code. Success is 202 with an empty body;
   a bad address comes back 400 with a JSON:API error pointing at
   /data/attributes/profile/data/attributes/email.

   The revision matters. Consent is stated in the request rather than left for
   Klaviyo to infer, and `profile.attributes.subscriptions` is only a valid
   field from 2025-01-15 onwards — on 2024-10-15 the same body is rejected with
   "'subscriptions' is not a valid field for the resource 'profile'". This is
   the same revision and the same consent block the footer form uses, so the
   two capture points cannot record consent differently.

   The endpoint answers 202 whether or not the address was already on the list —
   deliberately, so a form cannot be used to test whether someone shops here.
   "Already subscribed" is therefore decided from this device's own record and
   never claimed about anyone else.

   Frequency capping lives in localStorage under `dy:popup`:
     s  'subscribed' — never ask again, no expiry
        'dismissed'  — do not ask again until the cooldown has passed
     at last decision, ms
     n  how many times this person has closed it
     e  the address they gave, so a repeat submit is answered locally rather
        than posted again

   Storage can throw in private mode. Every access is guarded, and a failure
   degrades to "show once per tab" rather than to a popup on every page.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = document.querySelector('[data-dy-popup]');
  if (!root) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };

  var KEY = 'dy:popup';
  var TAB_KEY = 'dy:popup:tab';
  var EMAIL_REF_KEY = 'dy:from-email';

  /* Neither the scroll trigger nor exit intent may fire in the first few
     seconds. Someone who lands and immediately flicks to the bottom, or whose
     pointer leaves the window while the page is still painting, has not read
     anything yet — a popup at that moment is an interruption, not an offer.
     The delay trigger has its own setting and is not held back by this. */
  var SETTLE_MS = 4000;
  var REQUEST_TIMEOUT_MS = 12000;
  var REVISION = '2025-01-15';

  /* Written by _theme-extra-klaviyo.js, which owns the footer form and the
     back-in-stock block: a list of addresses this device has already
     subscribed. Read only. Someone who signed up in the footer must not then
     be interrupted by a popup asking for the same thing. The key belongs to
     that file, so nothing here writes to it. */
  var SHARED_KEY = 'dy:klaviyo:subscribed';

  function sharedSubscribed(email) {
    try {
      var raw = window.localStorage.getItem(SHARED_KEY);
      if (!raw) return false;
      var list = JSON.parse(raw);
      if (!Array.isArray(list)) return false;
      if (!email) return list.length > 0;
      return list.indexOf(String(email).toLowerCase()) !== -1;
    } catch (err) {
      return false;
    }
  }

  var FOCUSABLE =
    'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  /* ---------------------------------------------------------------- config */

  function num(name, fallback) {
    var v = parseFloat(root.getAttribute(name));
    return isFinite(v) ? v : fallback;
  }
  function flag(name) { return root.getAttribute(name) === 'true'; }

  var cfg = {
    company: root.getAttribute('data-company') || '',
    list: root.getAttribute('data-list') || '',
    source: root.getAttribute('data-source') || 'Site popup',
    delay: num('data-delay', 0) * 1000,
    scroll: num('data-scroll', 0),
    exit: flag('data-exit'),
    cooldown: num('data-cooldown', 14) * 86400000,
    maxAsks: num('data-max-asks', 3)
  };

  var box = $('[data-pop-box]');
  var form = $('[data-pop-form]');
  var input = $('[data-pop-email]');
  var submit = $('[data-pop-submit]');
  var submitLabel = $('[data-pop-label]');
  var msg = $('[data-pop-msg]');
  var live = $('[data-pop-live]');
  var stepAsk = $('[data-pop-step="ask"]');
  var stepDone = $('[data-pop-step="done"]');
  var doneTitle = $('[data-pop-done-title]');
  var doneLede = $('[data-pop-done-lede]');
  if (!box || !form || !input || !submit) return;

  var COPY = {
    idle: submitLabel ? submitLabel.textContent : 'Get the code',
    busy: root.getAttribute('data-copy-busy') || 'Adding you…',
    invalid: root.getAttribute('data-copy-invalid') || 'That address does not look right. Check it and try again.',
    failed: root.getAttribute('data-copy-failed') || 'We could not reach the mailing list, so nothing was saved. Try again in a moment.',
    busyList: root.getAttribute('data-copy-busy-list') || 'The mailing list is busy. Give it a few seconds and try again.',
    doneTitle: doneTitle ? doneTitle.textContent : '',
    doneLede: doneLede ? doneLede.textContent : '',
    againTitle: root.getAttribute('data-copy-again-title') || 'You already have this code.',
    againLede: root.getAttribute('data-copy-again-lede') || 'This device is already on the list, so we did not add you twice. Here is the code again.'
  };

  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* --------------------------------------------------------------- storage */

  function readState() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var v = raw ? JSON.parse(raw) : null;
      return v && typeof v === 'object' ? v : {};
    } catch (err) {
      return {};
    }
  }

  function writeState(next) {
    /* The theme editor must never write a cap: a merchant checking the popup
       would cap themselves out of their own preview. */
    if (designMode) return;
    try {
      window.localStorage.setItem(KEY, JSON.stringify(next));
    } catch (err) { /* private mode — capping falls back to the per-tab flag */ }
  }

  function tabFlag(set) {
    try {
      if (set) { window.sessionStorage.setItem(TAB_KEY, '1'); return true; }
      return window.sessionStorage.getItem(TAB_KEY) === '1';
    } catch (err) {
      return false;
    }
  }

  /* Someone who clicked through from an email is already on the list. The flag
     is remembered for the tab because the marker is only on the landing URL —
     one click deeper and it is gone. */
  function fromEmail() {
    var medium = '';
    try {
      medium = String(new URLSearchParams(window.location.search).get('utm_medium') || '').toLowerCase();
    } catch (err) {
      var m = window.location.search.match(/[?&]utm_medium=([^&]*)/);
      medium = m ? decodeURIComponent(m[1]).toLowerCase() : '';
    }
    if (medium === 'email') {
      try { window.sessionStorage.setItem(EMAIL_REF_KEY, '1'); } catch (err) { /* not essential */ }
      return true;
    }
    try { return window.sessionStorage.getItem(EMAIL_REF_KEY) === '1'; } catch (err) { return false; }
  }

  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name); } catch (err) { return null; }
  }

  /* ------------------------------------------------------------ may we ask */

  /* The menu drawer and the phone search sheet both sit above this layer and
     both own the page while they are up. Opening underneath one of them would
     put a focus trap behind a focus trap. */
  function menuOrSearchOpen() {
    if (document.body.classList.contains('drawer-open')) return true;
    var header = document.querySelector('.dy-header');
    return !!(header && header.classList.contains('q-open'));
  }

  /* Shopify's cookie banner is painted at z-index 2000000, because consent has
     to be reachable before anything else on the page. Asking for an email over
     the top of it would bury a choice the visitor is legally entitled to make
     first — and would lose anyway, since nothing in the theme can outrank it.

     The banner's own visibility is the only trustworthy signal.
     `Shopify.customerPrivacy.shouldShowBanner()` keeps answering true after the
     visitor has already chosen, so using it to decide when the banner has gone
     left the popup waiting for a banner that was no longer on screen. It is
     only consulted before the element exists, and only during the short window
     in which Shopify might still be injecting it. */
  var LOADED_AT = Date.now();
  var CONSENT_INJECT_GRACE_MS = 4000;

  function consentBannerOpen() {
    var el = document.getElementById('shopify-pc__banner');
    if (el) return el.offsetHeight > 0;
    if (Date.now() - LOADED_AT > CONSENT_INJECT_GRACE_MS) return false;
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.shouldShowBanner === 'function') return api.shouldShowBanner();
    } catch (err) { /* the privacy API is not always loaded */ }
    return false;
  }

  function blockedByOtherSurface() {
    return menuOrSearchOpen() || consentBannerOpen();
  }

  /* Runs the callback once the consent question is settled, immediately if
     there was never a banner.

     The cookie banner is on screen for every first-time visitor, so dropping
     the moment instead of waiting would mean most people never saw the popup
     at all. A menu or a search sheet is the opposite case: the visitor opened
     it themselves, and appearing the instant they close it reads as an ambush,
     so that moment really is skipped. */
  var consentWaiting = false;

  function whenConsentClear(cb) {
    if (!consentBannerOpen()) { cb(); return; }
    if (consentWaiting) return;
    consentWaiting = true;

    var tries = 0;
    var poll = null;

    var stop = function () {
      if (poll) { clearInterval(poll); poll = null; }
      document.removeEventListener('visitorConsentCollected', release);
      consentWaiting = false;
    };

    function release() {
      if (consentBannerOpen()) return;
      stop();
      cb();
    }

    /* Shopify announces the choice; the poll is the safety net for a banner
       dismissed in a way that does not raise the event. Capped so an ignored
       banner cannot leave a timer running for the whole visit. */
    document.addEventListener('visitorConsentCollected', release);
    poll = setInterval(function () {
      if (++tries > 180) {
        /* Three minutes of an untouched banner. Give up watching rather than
           keep a timer alive for the rest of the visit; the popup stays shut,
           which is the right outcome for someone who has not answered. */
        stop();
        return;
      }
      release();
    }, 1000);
  }

  function mayAsk() {
    if (designMode) return true;

    var forced = param('dypopup');
    if (forced === '0') return false;
    if (forced === '1') return true;

    if (fromEmail()) return false;
    if (tabFlag()) return false;

    var s = readState();
    if (s.s === 'subscribed') return false;
    /* Signed up at another capture point on this device — the footer form or
       a back-in-stock request that carried the newsletter tick. */
    if (sharedSubscribed(null)) return false;
    if ((s.n || 0) >= cfg.maxAsks) return false;
    if (s.s === 'dismissed' && s.at && Date.now() - s.at < cfg.cooldown) return false;

    return true;
  }

  /* ------------------------------------------------------------ open/close */

  var isOpen = false;
  var lastFocus = null;
  var locked = false;
  var disarm = null;

  function say(text) { if (live) live.textContent = text; }

  function lock() {
    if (locked) return;
    locked = true;
    /* Hiding the scrollbar reflows the page sideways wherever the platform
       still reserves room for one. Give the width back as padding so nothing
       moves as the dialog appears. */
    var gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.body.style.setProperty('--dy-sbw', gap + 'px');
    // The lock class must be on <html>: it is the scrolling element, and
    // putting overflow:hidden on Dawn's grid body clipped the page to white.
    document.documentElement.classList.add('dy-popup-open');
    document.body.classList.add('dy-popup-open');
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('dy-popup-open');
    document.body.classList.remove('dy-popup-open');
    document.body.style.removeProperty('--dy-sbw');
  }

  function open() {
    if (isOpen) return;
    if (!designMode && blockedByOtherSurface()) return;
    isOpen = true;
    if (disarm) { disarm(); disarm = null; }

    /* Nothing here was opened by a control, so there is usually nothing to
       return focus to. Where there is, it is remembered and restored. */
    var active = document.activeElement;
    lastFocus = active && active !== document.body ? active : null;

    root.hidden = false;
    root.removeAttribute('inert');

    /* Display is granted synchronously, before the lock. Deferring it to the
       next animation frame meant a throttled tab could scroll-lock the page
       while the dialog was still `display:none` — a blank white screen. */
    root.setAttribute('data-shown', '');

    lock();

    if (!designMode) tabFlag(true);

    /* One frame between display and the transition, or the box appears already
       in place and the movement is lost.

       Focus has to wait for that frame too. `[data-open]` is what gives the
       dialog a display value, and an element inside `display: none` cannot be
       focused — calling focus() before this ran silently did nothing and left
       the keyboard behind the scrim. */
    /* data-open safety: if the frame is dropped entirely the dialog is still
       displayed, it simply arrives without the transition. */
    setTimeout(function () {
      if (isOpen && !root.hasAttribute('data-open')) {
        root.setAttribute('data-open', '');
        if (box) box.focus();
      }
    }, 300);

    requestAnimationFrame(function () {
      root.setAttribute('data-open', '');
      /* The box, not the field. Landing on the input opens the keyboard over
         copy nobody has read yet, and a screen reader would announce the field
         label instead of the dialog. */
      if (isOpen) box.focus();
    });
  }

  /* `yield` is passed when another surface has taken over the page: the close
     still releases this file's own scroll lock, because that lock is a class
     nobody else touches and leaving it behind would keep the page unscrollable
     after the drawer that displaced us had closed. What yielding skips is the
     focus restore — the surface that took over has already moved focus — and
     the dismissal count, because nobody dismissed anything. */
  function close(reason) {
    if (!isOpen) return;
    isOpen = false;
    root.removeAttribute('data-open');
    root.removeAttribute('data-shown');
    root.setAttribute('inert', '');

    unlock();

    /* `inert` drops focus on its own; the element is only hidden afterwards so
       the exit transition can run. */
    var done = function () { if (!isOpen) root.hidden = true; };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else setTimeout(done, 320);

    if (reason !== 'yield' && lastFocus && lastFocus.isConnected && lastFocus.focus) lastFocus.focus();
    lastFocus = null;

    /* A dismissal counted from a forced preview would spend one of a real
       visitor's asks on this device. A real signup during a preview is still
       recorded, because it really happened. */
    if (reason === 'dismiss' && param('dypopup') !== '1') {
      var s = readState();
      writeState({ v: 1, s: 'subscribed' === s.s ? 'subscribed' : 'dismissed', at: Date.now(), n: (s.n || 0) + 1, e: s.e });
    }
  }

  /* -------------------------------------------------------------- triggers */

  function arm() {
    if (!mayAsk()) return;

    var timers = [];
    var cleaners = [];
    var armedAt = Date.now();
    var fired = false;

    function fire() {
      if (fired || isOpen) return;
      if (menuOrSearchOpen()) return;
      if (consentBannerOpen()) { whenConsentClear(fire); return; }
      fired = true;
      open();
    }

    function settled() { return Date.now() - armedAt >= SETTLE_MS; }

    disarm = function () {
      timers.forEach(clearTimeout);
      cleaners.forEach(function (fn) { fn(); });
      timers = [];
      cleaners = [];
    };

    /* `?dypopup=1` is how the merchant looks at the popup on a real page
       without waiting out a trigger or clearing storage first. It goes through
       fire() rather than open() so that it still waits out the cookie banner —
       calling open() directly would be refused while the banner is up and look
       as though the popup were broken. Like the theme editor, it writes no
       dismissal cap. */
    if (param('dypopup') === '1') { fire(); return; }

    if (cfg.delay > 0) {
      timers.push(setTimeout(fire, cfg.delay));
    }

    if (cfg.scroll > 0) {
      var ticking = false;

      var deepEnough = function () {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        /* A page shorter than the viewport has no scroll depth to reach, so
           this trigger stays silent rather than firing at once. */
        if (scrollable <= 0) return false;
        return (window.scrollY / scrollable) * 100 >= cfg.scroll;
      };

      var check = function () {
        if (!settled() || !deepEnough()) return;
        fire();
      };

      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (!deepEnough()) return;
          if (settled()) { fire(); return; }
          /* Deep enough, but too early. Someone who flicks to the bottom in the
             first seconds and then stops reading would otherwise never see the
             popup at all, because nothing would scroll again to re-test it.
             Re-check once when the settle window closes instead. */
          timers.push(setTimeout(check, SETTLE_MS - (Date.now() - armedAt)));
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      cleaners.push(function () { window.removeEventListener('scroll', onScroll); });
    }

    /* Exit intent needs a real pointer leaving the top edge of the window.
       Touch has no such gesture, and firing on a phone scroll-up would be a
       popup triggered by nothing the reader did. */
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (cfg.exit && fine) {
      var onOut = function (e) {
        if (!settled()) return;
        if (e.clientY > 0) return;
        if (e.relatedTarget) return;
        fire();
      };
      document.addEventListener('mouseout', onOut);
      cleaners.push(function () { document.removeEventListener('mouseout', onOut); });
    }
  }

  /* ----------------------------------------------------------------- state */

  function setStep(name) {
    var showDone = name === 'done';
    if (stepAsk) stepAsk.hidden = showDone;
    if (stepDone) stepDone.hidden = !showDone;
    /* The dialog's name has to follow the step, or it keeps announcing the
       heading of a panel that is no longer on screen. */
    var heading = showDone ? $('[data-pop-done-title]') : $('[data-pop-ask-title]');
    if (heading && heading.id) box.setAttribute('aria-labelledby', heading.id);
  }

  function showMessage(text, retry) {
    if (!msg) return;
    msg.textContent = '';
    msg.appendChild(document.createTextNode(text));
    if (retry) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pop__retry';
      b.setAttribute('data-pop-retry', '');
      b.textContent = 'Try again';
      msg.appendChild(document.createElement('br'));
      msg.appendChild(b);
    }
    msg.hidden = false;
    say(text);
  }

  function clearMessage() {
    if (!msg) return;
    msg.hidden = true;
    msg.textContent = '';
    input.removeAttribute('aria-invalid');
  }

  function busy(is) {
    submit.disabled = is;
    form.setAttribute('data-busy', is ? 'true' : 'false');
    if (submitLabel) submitLabel.textContent = is ? COPY.busy : COPY.idle;
    if (is) say(COPY.busy);
  }

  function succeed(email, already) {
    if (doneTitle) doneTitle.textContent = already ? COPY.againTitle : COPY.doneTitle;
    if (doneLede) doneLede.textContent = already ? COPY.againLede : COPY.doneLede;
    clearMessage();
    setStep('done');

    var s = readState();
    writeState({ v: 1, s: 'subscribed', at: Date.now(), n: s.n || 0, e: email });

    /* Move focus to the panel that replaced the form, otherwise focus is left
       on a button that is no longer in the document's visible flow. */
    box.focus();
    say((already ? COPY.againTitle : COPY.doneTitle) + ' ' + (root.getAttribute('data-code') || ''));
  }

  /* --------------------------------------------------------------- Klaviyo */

  /* A first pass only. Klaviyo is the authority on what it will accept, and it
     rejects a bad address with a 400 that is handled below. */
  function looksLikeEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function subscribe(email) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company);

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                /* Consent is stated, never left for Klaviyo to infer. This
                   store sells into the EU, where an implied opt-in is not an
                   opt-in. Requires revision 2025-01-15 or later. */
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                properties: { dy_signup_source: cfg.source }
              }
            }
          },
          custom_source: cfg.source
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };

    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, REQUEST_TIMEOUT_MS) : null;

    return fetch(url, {
      method: 'POST',
      headers: { revision: REVISION, 'content-type': 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      if (timer) clearTimeout(timer);
      return res;
    }, function (err) {
      if (timer) clearTimeout(timer);
      throw err;
    });
  }

  /* The onsite script is already on every page. Identifying the profile ties
     this session's browsing to the address that was just given, which is the
     whole reason the merchant has onsite tracking installed. It is optional —
     a failure here must not affect a subscription that already succeeded. */
  function identify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', { $email: email }]);
      }
    } catch (err) { /* tracking is not the contract; the subscription is */ }
  }

  var sending = false;

  function send() {
    if (sending) return;

    var email = String(input.value || '').trim();

    if (!email) {
      input.setAttribute('aria-invalid', 'true');
      showMessage(COPY.invalid);
      input.focus();
      return;
    }
    if (!looksLikeEmail(email)) {
      input.setAttribute('aria-invalid', 'true');
      showMessage(COPY.invalid);
      input.focus();
      return;
    }

    /* This device already gave this address, here or at another capture point.
       Posting it again would be a second write for nothing, so the answer
       comes from here. Klaviyo itself cannot tell us: it answers 202 for a new
       address and for one that has been on the list for a year, on purpose, so
       that a public endpoint cannot be used to test who shops here. */
    var prev = readState();
    var known = prev.e && prev.e.toLowerCase() === email.toLowerCase();
    if (known || sharedSubscribed(email)) {
      succeed(email, true);
      return;
    }

    if (!cfg.company || !cfg.list) {
      showMessage(COPY.failed, true);
      return;
    }

    clearMessage();
    sending = true;
    busy(true);

    subscribe(email).then(function (res) {
      sending = false;
      busy(false);

      /* 202 Accepted, empty body — Klaviyo queues the subscription. It answers
         the same way for an address that was already on the list, on purpose,
         so a form cannot be used to test who shops here. */
      if (res.status === 202 || res.status === 201 || res.status === 200) {
        identify(email);
        succeed(email, false);
        return;
      }

      if (res.status === 409) { succeed(email, true); return; }

      if (res.status === 429) {
        showMessage(COPY.busyList, true);
        return;
      }

      if (res.status === 400) {
        return res.json().then(function (data) {
          var errs = (data && data.errors) || [];
          var badEmail = errs.some(function (e) {
            return e && e.source && /profile.*email/.test(String(e.source.pointer || ''));
          });
          if (badEmail) {
            input.setAttribute('aria-invalid', 'true');
            showMessage(COPY.invalid);
            input.focus();
          } else {
            showMessage(COPY.failed, true);
          }
        }, function () {
          input.setAttribute('aria-invalid', 'true');
          showMessage(COPY.invalid);
          input.focus();
        });
      }

      showMessage(COPY.failed, true);
    }, function () {
      /* Offline, blocked by an extension, or timed out. Nothing was saved and
         the copy says so — a signup that quietly fails is worse than none. */
      sending = false;
      busy(false);
      showMessage(COPY.failed, true);
    });
  }

  /* ---------------------------------------------------------------- wiring */

  on(form, 'submit', function (e) { e.preventDefault(); send(); });
  on(input, 'input', function () {
    if (input.getAttribute('aria-invalid') === 'true') clearMessage();
  });

  on(root, 'click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-pop-retry]')) { clearMessage(); send(); return; }
    if (t.closest('[data-pop-close]')) { e.preventDefault(); close('dismiss'); return; }
    /* The scrim is the element itself, so a click on the padding around the
       box counts as a click outside it. */
    if (t.closest('[data-pop-scrim]')) { close('dismiss'); return; }
    if (t.closest('[data-copy]')) say('Code copied');
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;

    if (e.key === 'Escape') { e.preventDefault(); close('dismiss'); return; }
    if (e.key !== 'Tab') return;

    var items = $$(FOCUSABLE, box).filter(function (el) {
      return el.offsetParent !== null && !el.closest('[hidden]');
    });
    if (!items.length) { e.preventDefault(); box.focus(); return; }

    var first = items[0];
    var last = items[items.length - 1];
    /* The box itself holds focus when the dialog opens, so the first Tab has
       to be steered into the panel rather than out of it. */
    if (!box.contains(document.activeElement) || document.activeElement === box) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Yield the moment another surface takes the page.

     `childList` matters as much as the class filter. Shopify injects its cookie
     banner asynchronously, so a popup that opened first would otherwise sit
     underneath a consent choice it cannot outrank — the check before opening
     cannot see a banner that does not exist yet. Watching for the insertion
     makes the outcome the same whichever script wins the race. */
  if (typeof MutationObserver === 'function') {
    var watch = function () {
      if (!isOpen) return;
      if (menuOrSearchOpen()) { close('yield'); return; }
      if (!consentBannerOpen()) return;
      close('yield');
      /* Consent is a question the visitor did not ask for and must answer
         first. Once they have, the offer comes back. */
      whenConsentClear(function () {
        if (!menuOrSearchOpen()) open();
      });
    };
    new MutationObserver(watch).observe(document.body, {
      attributes: true, attributeFilter: ['class'], childList: true
    });
    var header = document.querySelector('.dy-header');
    if (header) new MutationObserver(watch).observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  /* A rotation or a tab restore must never leave the page locked. */
  on(window, 'pagehide', function () { if (isOpen) close('yield'); unlock(); });

  /* ------------------------------------------------------------ theme editor */

  /* Runs before the design-mode branch returns, so the dialog's name is bound
     to the panel on screen in the editor too. */
  setStep('ask');

  if (designMode) {
    /* The merchant has to be able to see what they are editing, so the caps
       are ignored here and nothing is written back to storage. */
    document.addEventListener('shopify:section:select', function (e) {
      if (root.closest('.shopify-section') === e.target) open();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (root.closest('.shopify-section') === e.target) close('editor');
    });
    return;
  }

  arm();
})();

/* ---- _theme-extra-search.js ---- */
/* ---------------------------------------------------------------------------
   Search behaviour — the header predictive panel.

   Everything here is an enhancement. With JavaScript off the form is a plain
   GET to /search, the magnifier is a real link to the same place, and the
   suggested kit types under the field are real <a href> links that already
   work. Nothing below is required to search this shop.

   Rows come from Shopify's own predictive-search endpoint, so every product,
   collection, page and article listed is one that exists here. Prices are the
   amounts Shopify returned for the visitor's active currency; when that
   currency is unknown the price is left out rather than guessed.

   Owns: the suggestion panel, its keyboard model, recent searches, and the
   full-screen phone sheet's scroll lock and dismissal.
   Does NOT own: the magnifier reveal or the `q-open` class — those stay in
   _theme-extra-header.js, and this file reacts to them.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };

  var STORE_KEY = 'dy:recent-search';
  var MAX_RECENT = 5;
  var MIN_CHARS = 2;
  var DEBOUNCE = 170;

  /* ------------------------------------------------- recent searches */
  /* Kept on this device only. Never sent anywhere, and clearable from the
     panel itself. Storage can throw in private mode, so every access is
     guarded and a failure simply means the feature is absent. */
  function readRecent() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list
        .filter(function (s) { return typeof s === 'string' && s.trim().length >= MIN_CHARS; })
        .slice(0, MAX_RECENT);
    } catch (err) {
      return [];
    }
  }

  function writeRecent(list) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
    } catch (err) { /* storage full or blocked — recent searches are optional */ }
  }

  function remember(term) {
    var t = String(term || '').trim();
    if (t.length < MIN_CHARS) return;
    var list = readRecent().filter(function (s) { return s.toLowerCase() !== t.toLowerCase(); });
    list.unshift(t);
    writeRecent(list);
  }

  function forgetAll() {
    try { window.localStorage.removeItem(STORE_KEY); } catch (err) { /* nothing to do */ }
  }

  /* ------------------------------------------------------- formatting */

  /* Every title in this catalogue is prefixed with the shop name. Showing it
     on every row wastes the width that the actual kit name needs. */
  function cleanTitle(value) {
    var t = String(value || '');
    var stripped = t.replace(/^\s*diyion\s*[™®]?\s*[|\-–]\s*/i, '').trim();
    return stripped || t;
  }

  function money(value, currency, lang) {
    var n = Number(value);
    if (!currency || !isFinite(n)) return '';
    try {
      return new Intl.NumberFormat(lang || 'en', { style: 'currency', currency: currency }).format(n);
    } catch (err) {
      return '';
    }
  }

  /* A kit whose variants span a range must not be labelled with its cheapest
     variant as though that were the price. */
  function priceLabel(p, currency, lang) {
    var lo = p.price_min != null ? p.price_min : p.price;
    var hi = p.price_max != null ? p.price_max : p.price;
    var text = money(lo, currency, lang);
    if (!text) return '';
    return Number(hi) > Number(lo) ? 'From ' + text : text;
  }

  function highlight(host, text, term) {
    var t = String(text == null ? '' : text);
    var needle = String(term || '').trim();
    var at = needle ? t.toLowerCase().indexOf(needle.toLowerCase()) : -1;
    if (at < 0) { host.appendChild(document.createTextNode(t)); return; }
    host.appendChild(document.createTextNode(t.slice(0, at)));
    var mark = document.createElement('mark');
    mark.appendChild(document.createTextNode(t.slice(at, at + needle.length)));
    host.appendChild(mark);
    host.appendChild(document.createTextNode(t.slice(at + needle.length)));
  }

  var GLYPHS = {
    collection: 'M2.5 4.5h11M2.5 8h11M2.5 11.5h7',
    page: 'M4 2.5h5.5L12 5v8.5H4z',
    article: 'M3 3.5h10v9H3zM5.5 6.5h5M5.5 9h3',
    query: 'M7.2 2.6a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2ZM10.6 10.6 14 14',
    recent: 'M8 3.6v4.6l3 1.7M8 2.4a5.6 5.6 0 1 0 0 11.2A5.6 5.6 0 0 0 8 2.4Z'
  };

  function glyph(kind) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', GLYPHS[kind] || GLYPHS.query);
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    var span = document.createElement('span');
    span.className = 'sx__gl';
    span.appendChild(svg);
    return span;
  }

  function thumb(url) {
    if (!url) return null;
    var img = document.createElement('img');
    img.className = 'sx__th';
    img.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=128';
    img.width = 44;
    img.height = 44;
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    return img;
  }

  /* ------------------------------------------------------- one form */

  function wire(form) {
    var input = $('[data-sx-input]', form);
    var panel = $('[data-sx-panel]', form);
    var list = $('[data-sx-list]', form);
    var dyn = $('[data-sx-dyn]', form);
    var seed = $('[data-sx-seed]', form);
    var recent = $('[data-sx-recent]', form);
    var recentList = $('[data-sx-recent-list]', form);
    var state = $('[data-sx-state]', form);
    var skeleton = $('[data-sx-skeleton]', form);
    var live = $('[data-sx-live]', form);
    var clearBtn = $('[data-sx-clear]', form);
    var foot = $('[data-sx-foot]', form);
    var wipe = $('[data-sx-wipe]', form);
    if (!input || !panel || !list || !dyn) return;

    var endpoint = form.getAttribute('data-sx-url') || '';
    var action = form.getAttribute('action') || '/search';
    var currency = form.getAttribute('data-sx-currency') || '';
    var uid = form.getAttribute('data-sx-uid') || 'sx';
    var lang = document.documentElement.lang || 'en';

    var timer = null;
    var ctrl = null;
    var seq = 0;
    var cache = Object.create(null);
    var active = null;

    /* Two lists write rows into this panel — the predictive results and the
       recent searches — and they are painted independently. A single counter
       therefore handed the same id to a result row and to a recent row that
       was still in the DOM behind the hidden seed block, so the document
       carried duplicate ids and `aria-activedescendant` resolved to whichever
       came first rather than to the row the arrow keys had highlighted. Each
       list gets its own namespace. */
    var rowN = { o: 0, r: 0 };

    function searchHref(term) {
      return action + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
    }

    /* ---------- row construction ---------- */

    function row(opts) {
      var a = document.createElement('a');
      var ns = opts.ns || 'o';
      a.className = opts.plain ? 'sx__all' : 'sx__r';
      a.id = uid + '-' + ns + rowN[ns]++;
      a.href = opts.href;
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');
      /* Options are reached with the arrow keys and aria-activedescendant, so
         they stay out of the tab order — Tab leaves the field, as it should. */
      a.setAttribute('tabindex', '-1');
      if (opts.term) a.setAttribute('data-sx-term', opts.term);

      if (opts.plain) {
        a.appendChild(document.createTextNode(opts.title));
        return a;
      }

      var media = opts.image ? thumb(opts.image) : glyph(opts.glyph);
      if (media) a.appendChild(media);

      var col = document.createElement('span');
      col.className = 'sx__rc';

      var title = document.createElement('span');
      title.className = 'sx__rt';
      highlight(title, opts.title, opts.match);
      col.appendChild(title);

      if (opts.kind) {
        var kind = document.createElement('span');
        kind.className = 'sx__k';
        kind.textContent = opts.kind;
        col.appendChild(kind);
      }
      a.appendChild(col);

      if (opts.price) {
        var price = document.createElement('span');
        price.className = 'sx__rp';
        price.textContent = opts.price;
        a.appendChild(price);
      }
      return a;
    }

    function group(label) {
      var g = document.createElement('div');
      g.className = 'sx__grp';
      g.setAttribute('role', 'group');
      g.setAttribute('aria-label', label);
      var h = document.createElement('p');
      h.className = 'sx__h';
      h.setAttribute('role', 'presentation');
      h.textContent = label;
      g.appendChild(h);
      return g;
    }

    /* ---------- open / close ---------- */

    function collect() {
      return $$('[role="option"]', panel).filter(function (el) { return !el.closest('[hidden]'); });
    }

    function setActive(el) {
      var all = collect();
      all.forEach(function (o) { o.setAttribute('aria-selected', o === el ? 'true' : 'false'); });
      active = el || null;
      if (active) {
        input.setAttribute('aria-activedescendant', active.id);
        if (active.scrollIntoView) active.scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function open() {
      if (!panel.hidden) return;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (panel.hidden) return;
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      setActive(null);
    }

    function say(text) {
      if (live) live.textContent = text;
    }

    function busy(is) {
      form.setAttribute('data-busy', is ? 'true' : 'false');
      panel.setAttribute('aria-busy', is ? 'true' : 'false');
      /* A skeleton only helps when there is nothing on screen to keep. Once
         results exist, replacing them with grey bars is a step backwards. */
      if (skeleton) skeleton.hidden = !(is && !dyn.firstChild);
    }

    function showSeed(show) {
      if (seed) seed.hidden = !show;
    }

    function message(text, isError) {
      if (!state) return;
      state.textContent = text;
      state.className = 'sx__state' + (isError ? ' sx__state--err' : '');
      state.hidden = false;
    }

    function clearMessage() {
      if (state) { state.hidden = true; state.textContent = ''; }
    }

    /* ---------- recent ---------- */

    function paintRecent() {
      if (!recent || !recentList) return;
      var items = readRecent();
      recentList.textContent = '';
      rowN.r = 0;
      if (!items.length) {
        recent.hidden = true;
        if (foot) foot.hidden = true;
        return;
      }
      items.forEach(function (t) {
        recentList.appendChild(row({
          ns: 'r', href: searchHref(t), title: t, kind: 'Recent search', glyph: 'recent', term: t
        }));
      });
      recent.hidden = false;
      if (foot) foot.hidden = false;
    }

    /* ---------- results ---------- */

    function paint(data, term) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var pages = res.pages || [];
      var articles = res.articles || [];
      var queries = res.queries || [];

      dyn.textContent = '';
      rowN.o = 0;
      setActive(null);
      clearMessage();

      var count = 0;

      if (products.length) {
        var gp = group('Kits');
        products.slice(0, 5).forEach(function (p) {
          gp.appendChild(row({
            href: p.url,
            title: cleanTitle(p.title),
            match: term,
            kind: (p.product_type || p.type || 'Kit'),
            image: p.image || (p.featured_image && p.featured_image.url) || '',
            price: priceLabel(p, currency, lang)
          }));
          count++;
        });
        dyn.appendChild(gp);
      }

      if (collections.length) {
        var gc = group('Collections');
        collections.slice(0, 3).forEach(function (c) {
          gc.appendChild(row({
            href: c.url, title: cleanTitle(c.title), match: term,
            kind: 'Collection', glyph: 'collection'
          }));
          count++;
        });
        dyn.appendChild(gc);
      }

      var content = pages.slice(0, 2).map(function (p) { return { item: p, kind: 'Page', glyph: 'page' }; })
        .concat(articles.slice(0, 2).map(function (a) { return { item: a, kind: 'Guide', glyph: 'article' }; }));
      if (content.length) {
        var gg = group('Pages and guides');
        content.forEach(function (entry) {
          gg.appendChild(row({
            href: entry.item.url, title: entry.item.title, match: term,
            kind: entry.kind, glyph: entry.glyph
          }));
          count++;
        });
        dyn.appendChild(gg);
      }

      /* Query suggestions are only worth the space when nothing matched
         directly — otherwise they push real results below the fold. */
      if (!count && queries.length) {
        var gq = group('Try searching for');
        queries.slice(0, 4).forEach(function (q) {
          gq.appendChild(row({
            href: q.url || searchHref(q.text), title: q.text, match: term,
            kind: 'Search', glyph: 'query', term: q.text
          }));
          count++;
        });
        dyn.appendChild(gq);
      }

      if (count) {
        dyn.appendChild(row({ plain: true, href: searchHref(term), title: 'See all results for “' + term + '”', term: term }));
        showSeed(false);
        say(count + (count === 1 ? ' suggestion' : ' suggestions') + ' for ' + term);
      } else {
        /* An empty result is never a dead end: the kit types stay on screen so
           there is always somewhere to go next. */
        message('Nothing matched “' + term + '”. Try a kit type, a room, or the material.');
        showSeed(true);
        say('No suggestions for ' + term);
      }

      open();
    }

    function fail(term) {
      dyn.textContent = '';
      rowN.o = 0;
      setActive(null);
      message('Suggestions are not loading right now. Press Enter to search for “' + term + '”.', true);
      showSeed(true);
      say('Suggestions unavailable. Press Enter to search.');
      open();
    }

    function request(term) {
      var mine = ++seq;

      if (cache[term]) { busy(false); paint(cache[term], term); return; }

      if (ctrl && ctrl.abort) { try { ctrl.abort(); } catch (err) { /* already done */ } }
      ctrl = typeof AbortController === 'function' ? new AbortController() : null;

      var url = endpoint + '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page,article,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      busy(true);
      open();

      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          /* A slow reply from an older keystroke must never replace a newer
             one. The sequence check does that even where fetch cannot abort. */
          if (mine !== seq) return;
          cache[term] = data;
          busy(false);
          paint(data, term);
        })
        .catch(function (err) {
          if (mine !== seq) return;
          if (err && err.name === 'AbortError') return;
          busy(false);
          fail(term);
        });
    }

    function idle() {
      if (timer) { clearTimeout(timer); timer = null; }
      seq++;
      busy(false);
      dyn.textContent = '';
      rowN.o = 0;
      setActive(null);
      clearMessage();
      paintRecent();
      showSeed(true);
    }

    /* ---------- wiring ---------- */

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    paintRecent();
    if (clearBtn) clearBtn.hidden = !input.value;

    on(input, 'input', function () {
      var term = input.value.trim();
      if (clearBtn) clearBtn.hidden = !input.value;
      if (timer) clearTimeout(timer);

      if (term.length < MIN_CHARS) { idle(); open(); return; }
      if (!endpoint) return;

      timer = setTimeout(function () { request(term); }, DEBOUNCE);
    });

    on(input, 'focus', function () {
      if (input.value.trim().length < MIN_CHARS) { paintRecent(); showSeed(true); }
      open();
    });

    on(input, 'keydown', function (e) {
      var key = e.key;

      if (key === 'Escape') {
        /* First Escape closes the suggestions. Only when they are already
           closed does the event reach the header, which shuts the whole
           panel and puts focus back on the magnifier. */
        if (!panel.hidden) { e.stopPropagation(); close(); input.select(); }
        return;
      }

      if (key === 'Tab') { close(); return; }

      if (key === 'ArrowDown' || key === 'ArrowUp') {
        if (panel.hidden) open();
        var opts = collect();
        if (!opts.length) return;
        e.preventDefault();
        var at = active ? opts.indexOf(active) : -1;
        var next;
        if (key === 'ArrowDown') next = at < 0 || at === opts.length - 1 ? 0 : at + 1;
        else next = at <= 0 ? opts.length - 1 : at - 1;
        setActive(opts[next]);
        return;
      }

      if (key === 'Home' && active) { e.preventDefault(); setActive(collect()[0]); return; }
      if (key === 'End' && active) {
        e.preventDefault();
        var all = collect();
        setActive(all[all.length - 1]);
        return;
      }

      if (key === 'Enter') {
        if (!active) return;                       // let the form submit normally
        e.preventDefault();
        remember(active.getAttribute('data-sx-term') || input.value);
        active.click();
      }
    });

    /* Pointer and keyboard agree on what is highlighted. */
    on(panel, 'mousemove', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('[role="option"]') : null;
      if (opt && opt !== active) setActive(opt);
    });

    /* Keep the field focused while a row is being pressed.

       Safari and iOS do not move focus to a link on mousedown. Without this,
       pressing a suggestion blurred the input, `focusout` fired with a null
       relatedTarget, the panel was hidden between mousedown and mouseup, and
       the click landed on whatever had moved underneath — so on the browser
       most of this shop's phone traffic uses, the suggestions were not
       reliably tappable at all. Preventing the default on mousedown stops the
       focus change; it does not stop the click, so the anchor still navigates
       and the `click` handler below still records the term. */
    on(panel, 'mousedown', function (e) {
      if (e.target && e.target.closest && e.target.closest('[role="option"]')) e.preventDefault();
    });

    on(panel, 'click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('[role="option"]') : null;
      if (!opt) return;
      remember(opt.getAttribute('data-sx-term') || input.value);
    });

    on(form, 'submit', function () { remember(input.value); });

    on(clearBtn, 'click', function () {
      input.value = '';
      if (clearBtn) clearBtn.hidden = true;
      idle();
      open();
      input.focus();
    });

    on(wipe, 'click', function () {
      forgetAll();
      paintRecent();
      say('Recent searches cleared');
      input.focus();
    });

    on(document, 'click', function (e) {
      var t = e.target;
      if (!t) return;
      if (form.contains(t)) return;
      /* The magnifier that reveals this form sits outside it. Without this the
         same click that opened the panel and focused the field closed it
         again, and the panel only appeared on the second tap. */
      if (t.closest && t.closest('[data-q-toggle]')) return;
      close();
    });

    on(form, 'focusout', function (e) {
      if (!e.relatedTarget || !form.contains(e.relatedTarget)) close();
    });

    /* Expose a close for the sheet controller below. */
    form.dyCloseSuggest = close;
  }

  $$('[data-sx]').forEach(wire);

  /* ------------------------------------------- the phone search sheet */
  /* Below 768px the header's `q-open` class turns the form into a full-screen
     sheet. The class itself is set by _theme-extra-header.js — this watches it
     so the lock and the dismissals stay correct no matter who toggled it. */

  var header = $('.dy-header');
  if (!header) return;

  var toggle = $('[data-q-toggle]', header);
  var phone = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var locked = false;
  var prevOverflow = '';

  function lock() {
    /* The drawer already owns body overflow when it is open. Two owners of one
       style is how a page ends up permanently unscrollable. */
    if (locked || document.body.classList.contains('drawer-open')) return;
    locked = true;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    document.body.style.overflow = prevOverflow;
    prevOverflow = '';
  }

  function sync() {
    var open = header.classList.contains('q-open');
    if (open && phone && phone.matches) lock();
    else unlock();
    if (!open) {
      /* Only the copy in the bar is governed by `q-open`. The drawer has its
         own form and must keep whatever it is showing. */
      $$('.nav [data-sx]', header).forEach(function (f) {
        if (typeof f.dyCloseSuggest === 'function') f.dyCloseSuggest();
      });
    }
  }

  if (typeof MutationObserver === 'function') {
    new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class'] });
  }
  if (phone) {
    if (phone.addEventListener) phone.addEventListener('change', sync);
    else if (phone.addListener) phone.addListener(sync);
  }

  function closeSheet() {
    if (!header.classList.contains('q-open')) return;
    header.classList.remove('q-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
    unlock();
  }

  on(document, 'click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-sx-close]')) {
      e.preventDefault();
      closeSheet();
    }
  });

  /* A rotation or a resize out of phone width must not leave the body locked. */
  on(window, 'pagehide', unlock);
})();

/* ---- _theme-extra.js ---- */
/* ---------------------------------------------------------------------------
   Theme-only behaviour the prototype did not need.
   Appended by theme-build.mjs so it survives a rebuild.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* Utility-bar discount code: click to copy. */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-copy]');
    if (!el) return;
    var code = el.getAttribute('data-copy');
    var label = el.querySelector('em');
    var done = function (ok) {
      if (!label) return;
      var prev = label.textContent;
      label.textContent = ok ? 'Copied' : 'Press ⌘C';
      el.classList.add('copied');
      setTimeout(function () {
        label.textContent = prev;
        el.classList.remove('copied');
      }, 1600);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(false); });
      return;
    }
    // Fallback that never focuses a visible field (no mobile keyboard pop).
    var ta = document.createElement('textarea');
    ta.value = code;
    ta.setAttribute('readonly', '');
    ta.setAttribute('tabindex', '-1');
    ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
    document.body.removeChild(ta);
    done(ok);
  });

  /* Lamp state, persistence and aria-pressed are owned by _core.js.
     Nothing to add here. */
})();
